import React, { useEffect, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import QuotationList from "./QuotationList";
import QuotationForm from "./QuotationForm";
import { getQuotations } from '../api/quotationService';
import { toast } from "react-toastify";


function QuotationPage() {
    const [quotations, setQuotations] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const fetchQuotations = async () => {
        setLoading(true);
        try {
            const response = await getQuotations(1, 20); // page=1, pageSize=20
            if (response?.data) {
                setQuotations(response.data);
            }
        } catch (error) {
            console.error("Error fetching quotations:", error);
            toast.error("Failed to load quotations ❌");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchQuotations();
    }, []);

    const handleAddQuotation = () => {
        fetchQuotations(); // re-fetch from backend after add
        navigate("/quotations");
    };

    return (
        <Routes>
            <Route
                path="/"
                element={
                    <QuotationList
                        quotations={quotations}
                        loading={loading}
                        onRefresh={fetchQuotations}
                    />
                }
            />
            <Route
                path="/new"
                element={<QuotationForm onAddQuotation={handleAddQuotation} />}
            />
        </Routes>
    );
}

export default QuotationPage;
